import { FormField } from 'types';

export const getRequisitesFieldsForCurrency = (
  fields: FormField[],
  currencyCode?: string,
): FormField[] =>
  fields.filter(
    ({ visibleForCurrencies }) =>
      !visibleForCurrencies ||
      (!!currencyCode && visibleForCurrencies.includes(currencyCode)),
  );
